import { Vue } from 'vue-class-component';

export default class ImageMixin extends Vue {
  images: __WebpackModuleApi.RequireContext;

  imageURL(path: string) {
    return this.images.keys().includes(`./${path}`) ? this.images(`./${path}`) : '';
  }

  created() {
    this.images = require.context('../../assets/', true, /\.png$|\.jpg$/);
  }
}
